module.exports = __webpack_public_path__ + "static/media/pattern5.14cf43e4.png";